// Expects a mapped string from settings/IB getClientCodes (not a dispatch entry object)
const getServiceLevelEntry = (value) => ({
  mappedServiceLevel: value || '',
  serviceLevel: value || '',
});

// Convert a list of mapped strings into the shared entry shape
const getServiceLevelEntries = (serviceLevelList) =>
  (serviceLevelList || []).map(getServiceLevelEntry);

// Option value / match key (mappedServiceLevel)
const getServiceLevelValue = (entry) =>
  entry?.mappedServiceLevel || entry?.serviceLevel || '';

// Option label / display text (serviceLevel)
const getServiceLevelLabel = (entry) =>
  entry?.serviceLevel || entry?.mappedServiceLevel || '';

const getServiceLevelValues = (serviceLevelList) =>
  serviceLevelList?.map(getServiceLevelValue) || [];

const getServiceLevelLabels = (serviceLevelList) =>
  serviceLevelList?.map(getServiceLevelLabel) || [];

const toPriorityList = (priority) =>
  Array.isArray(priority) ? priority : priority ? [priority] : [];

const findServiceLevelEntry = (priority, serviceLevelList) => {
  if (!priority) return undefined;
  return (serviceLevelList || []).find(
    (entry) =>
      getServiceLevelValue(entry) === priority ||
      getServiceLevelLabel(entry) === priority
  );
};

const getDisplayServiceLevel = (priority, serviceLevelList) => {
  if (!priority) return '';
  const entry = findServiceLevelEntry(priority, serviceLevelList);
  return entry ? getServiceLevelLabel(entry) : priority;
};

const getDisplayServiceLevels = (priorities, serviceLevelList) =>
  toPriorityList(priorities).map((priority) =>
    getDisplayServiceLevel(priority, serviceLevelList)
  );

export {
  getServiceLevelEntry,
  getServiceLevelEntries,
  getServiceLevelValue,
  getServiceLevelLabel,
  getServiceLevelValues,
  getServiceLevelLabels,
  toPriorityList,
  findServiceLevelEntry,
  getDisplayServiceLevel,
  getDisplayServiceLevels
};
